enum TScenario {
  employeesHabits = "employees_habits",
  simplifiedLca = "simplified_lca",
  events = "events",
  travels = "travels",
  free = "free",
}

type TSimulation = {
  id: number;
  name: string;
  period_start: string;
  period_end: string;
  carbon_tons: number;
  employees: number;
  details_url: string;
  scenario?: TScenario;
};

type TCategory =
  | "business_trip"
  | "furniture"
  | "marketing"
  | "office"
  | "operations"
  | "other"
  | "saas_telecommunication"
  | "support"
  | "transport"
  | "usage";

type TSubCategory = string;

type TSubCategoryStatus = Record<TSubCategory, boolean>;

export type { TCategory, TSimulation, TSubCategory, TSubCategoryStatus };
export { TScenario };
